import axios from "axios";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import Hn from "../../components/common/Hn";
import Add from "../../assets/icons/add.png";
import Close from "../../assets/icons/Close.png";
import { createBrowserHistory } from "history";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Updatethematique() {
  const params = useParams();
  const [thematique, setThematique] = useState([]);
  const uri = process.env.REACT_APP_BASE_URL;
  let history = createBrowserHistory({ forceRefresh: true });
  //modifier une thématique
  const handleSubmit = (values) => {
    let newitem = [];


    const uri = process.env.REACT_APP_BASE_URL;

    const headersFiles = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let ix = [];
    values?.soustheme.map((item) => {
        {item?.id ? ix.push(item.name) : ix.push(item)}
    });
  
    let data = {
      ref: values.reference,
      name: values.nom,
      slug: values.slug,
      subtheme: ix,
    };
  
    axios
      .put(uri + `/thematic/edit/` + values.id, data, headersFiles)
      .then((result) => {
        history.push("/admin/thematique");
    
      })
      .catch((err) => {
        console.log("err training", err);
      });
  };
//récupérer une thématique choisie par son id
  function gethematique(id) {
    axios
      .get(uri + `/thematic/${params.id}`)
      .then((result) => {
        setThematique(result?.data);
      
      })
      .catch((err) => {
        console.log("err location", err);
      });
  }

  useEffect(() => {
    gethematique(params.id);
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container lists p-5">
          <nav aria-label="breadcrumb pb-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/admin/thematique">Thématique</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                modifier une thématique
              </li>
            </ol>
          </nav>
          <div className="h-100 p-5 text-white bg-dark rounded-3">
            <Hn
              title="Modifier une thématique"
              level="h4"
              className="h4-size pb-5"
              plus={false}
            />

            <div className="form-elements">
              <Formik
                enableReinitialize
                initialValues={{
                  id: thematique.id,
                  reference: thematique.ref,
                  slug: thematique.slug,
                  nom: thematique.name,
                  soustheme: thematique?.subtheme,
                }}
                onSubmit={handleSubmit}
                // validationSchema={Yup.object().shape({

                //   reference: Yup.string(),
                //   nom: Yup.string(),

                // })}
                render={({ values, errors, handleChange }) => (
                  <Form>
                    <div className="row">
                      <div className="col-4">
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Référence
                          </label>
                          <Field
                            className="form-control"
                            name="reference"
                            placeholder="Réference"
                            onChange={handleChange}
                            defaultvalue={thematique.ref}
                          />
                          <ErrorMessage
                            className="form-text text-danger"
                            name="reference"
                          />
                        </div>
                        <Field
                          className="form-control"
                          name="id"
                          type="hidden"
                          defaultvalue={thematique.id}
                        />
                        <Field
                          className="form-control"
                          name="slug"
                          type="hidden"
                          defaultvalue={thematique.slug}
                        />
                      </div>
                      <div className="col-8">
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Nom de la thématique
                          </label>
                          <Field
                            className="form-control"
                            name="nom"
                            onChange={handleChange}
                            placeholder="Nom"
                            defaultvalue={thematique.name}
                          />
                          <ErrorMessage
                            className="form-text text-danger"
                            name="nom"
                          />
                        </div>
                      </div>
                    </div>
                    <label htmlFor="" className="form-label">
                      Sous-thème
                    </label>

                    <FieldArray
                      name="soustheme"
                      render={(arrayHelpers) => (
                        <div className="">
                          {values?.soustheme?.map((val, index) => (
                            <div className="row" key={index}>
                              <div className="col-8">
                                <div className="mb-3">
                                  <Field
                                    className="form-control"
                                    name={`soustheme.${index}`}
                                    placeholder="Sous thématique"
                                    onChange={handleChange}
                                    defaultvalue={val.name}
                                    value={val.name}
                                  />
                                  <ErrorMessage
                                    className="form-text text-danger"
                                    name={`soustheme.${index}`}
                                  />
                                </div>
                              </div>
                              <div className="col-2 mt-4">
                                <span
                                  type="button"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  <img
                                    src={Close}
                                    className="pe-1"
                                    style={{
                                      marginTop: "-34px",
                                      marginLeft: "-10px",
                                    }}
                                  />
                                </span>
                              </div>
                            </div>
                          ))}

                          <span
                            onClick={() =>
                              arrayHelpers.insert(values.soustheme.length, {
                                soustheme: "",
                              })
                            }
                            style={{ color: "#0d6efd" }}
                          >
                            <img src={Add} className="pe-1" /> Ajouter un sous
                            thème
                          </span>
                          <div className="col-12 pt-5">
                            <a
                              type="reset"
                              className="btn btn-link resetBtn"
                              href="/admin/thematique"
                            >
                              Annuler
                            </a>
                            <button
                              type="submit"
                              className="btn btn-primary float-end "
                            >
                              Valider
                            </button>
                          </div>
                        </div>
                      )}
                    />
                  </Form>
                )}
              />
            </div>
          </div>
        </div>
        {/* lists */}
      </div>
    </div>
  );
}
